import React, { useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Notification } from "./Notification";
import Header from "./Header";
import Home from "./Home";
import { useHistory } from "react-router";

function ResetPassword() {
  const passwordRef = useRef();
  const passwordConfirmRef = useRef();
  const passwordCurrentRef = useRef();
  const [loading, setLoading] = useState(false);
  const { resetPassword, logout, setGlobalNot } = useAuth();
  const [passwordError, setPasswordError] = useState();
  const history = useHistory();
  const back = useState("< GERI");

  const formValidation = (password) => {
    var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;

    if (!password.match(passw)) {
      setPasswordError(
        "Şifreniz rakam, büyük harf ve küçük harf içeren 6-20 karakter uzunluğunda oluşmalı"
      );
      return false;
    }
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      setPasswordError("Hatalı şifre tekrarı");
      return false;
    }
    return true;
  };

  const handleBack = (e) => {
    e.preventDefault();
    history.push("/account");
  };

  const handleResetPassword = (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      if (passwordRef.current.value !== passwordConfirmRef.current.value) {
        setPasswordError("şifre tekrarı aynı değil");
        return;
      }
      const validationResult = formValidation(passwordRef.current.value);
      if (!validationResult) {
        setLoading(false);
        return;
      }
      resetPassword(
        passwordCurrentRef.current.value,
        passwordRef.current.value
      ).then((response) => {
        console.log("resetpasswordhanlde result: ", response);
        if (response === "şifre değiştirildi") {
          logout();
          setGlobalNot("Şifreniz değiştirildi. Giriş yapabilirsiniz.");
          history.push("/login");
        }
      });
    } catch {
      console.log("failed to change password");
    }
    setLoading(false);
  };

  return (
    <div>
      <Header />
      <Home />
      <div className="login">
        <div className="register__container">
          <form onSubmit={handleResetPassword} className="login__form">
            <h1>SIFRE DEGISTIRME</h1>
            <div className="h5">
              <h5>MEVCUT SIFRE</h5>
            </div>

            <div className="input">
              <input type="password" ref={passwordCurrentRef} required />
            </div>
            <div className="h5">
              <h5>YENI SIFRE</h5>
            </div>

            <div className="input">
              <input type="password" ref={passwordRef} required />
            </div>
            <div className="h5">
              <h5>YENI SIFRE TEKRARI</h5>
            </div>

            <div className="input">
              <input type="password" ref={passwordConfirmRef} required />
            </div>

            {passwordError && <Notification notification={passwordError} />}
            <div className="resetPasswordButton">
              <div className="button">
                <button onClick={handleBack} className="login__signInButton">
                  {back}
                </button>
              </div>
              <div className="register__buttons">
                <div className="button">
                  <button
                    disabled={loading}
                    type="submit"
                    className="login__signInButton"
                  >
                    SIFREMI DEGISTIR
                  </button>
                </div>
              </div>
            </div>

            <div className="topLeftBorder">
              <div>
                <div className="borderTop"></div>
                <div className="borderLeft"></div>
              </div>
            </div>
            <div className="bottomRigtBorder">
              <div>
                <div className="borderRight"></div>
                <div className="borderBottom"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
